import { i18n, isAuth, opt } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import * as React from 'react';
import { connect } from 'react-redux';
import Editor from 'react-simple-code-editor';
import { isNullOrUndefined } from 'util';
import AppActions from '../../app/app_actions';
import GaranzieTable from '../garanzie/garanzieTable.jsx';
import BtnDelete from '../shared/BtnDelete.jsx';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx';
import CompagniaTable from './compagniaTable.jsx';
import FrazionamentoTable from './FrazionamentiTable.jsx';
import IntermediariTable from './intermediariTable.jsx';
import OperazioniTable from './operazioneTable.jsx';
import PagamentoTable from './PagamentoTable.jsx';
import ProdottoConvenzione from './prodottoConvenzione.jsx';
import ProdottoDetailsCard from './prodottoDetailsCard.jsx';
import ProdottoDocument from './prodottoDocument.jsx';
import ProdottoDocumentPolizza from './prodottoDocumentPolizza.jsx';
import ProdottoDocumentUpload from './prodottoDocumentUpload.jsx';
import ProdottoLinea from './prodottoLinea.jsx';
import ProdottoQuotazione from './prodottoQuotazione.jsx';
import ProdottoServiziEsterni from './prodottoServiziEsterni.jsx';
import ProdottoSinistri from './prodottoSinistri.jsx';
import ProdottoTable from './prodottoTable.jsx';
import ProdottoActions from './prodotto_actions';
import ProvvigioniTable from './provvigioniTable.jsx';
import ProdottoPacchetto from './prodottoPacchetto.jsx';
import ProdottoDocumentPrint from './prodottoDocumentPrint.jsx'
import DurataTable from './DurataTable.jsx';
import ScontoTable from './ScontoTable.jsx';
import FirmaDigitale from './firmaDigitale.jsx';
import RegolaProduct from './RegolaProduct.jsx';

class ProdottoDetails extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ProdottoDetails.jsx] ';
        this.modificaProdottoButton = this.modificaProdottoButton.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteProdotto = this.deleteProdotto.bind(this);
        this.changeSelectedTab = this.changeSelectedTab.bind(this);
        this.modificaProvvigioniButton = this.modificaProvvigioniButton.bind(this);
        this.microCategoriaDetailsButton = this.microCategoriaDetailsButton.bind(this);
        this.modificaProvvigioniPassiveButton = this.modificaProvvigioniPassiveButton.bind(this);
        this.prodottoFiglioDetailsButton = this.prodottoFiglioDetailsButton.bind(this);
        this.prodottoPadreDetailsButton = this.prodottoPadreDetailsButton.bind(this);
        this.prodottoOrigineDetailsButton = this.prodottoOrigineDetailsButton.bind(this);
        this.nuovoVersioneButton = this.nuovoVersioneButton.bind(this);
        // this.questionarioPreviewButton = this.questionarioPreviewButton.bind(this);
        this.indietroButton = this.indietroButton.bind(this);
        this.tornaAllaLista = this.tornaAllaLista.bind(this);
        this.downloadDocument = this.downloadDocument.bind(this);
        this.showConfirmPanelUpload = this.showConfirmPanelUpload.bind(this);
        this.inputChangeHandlerDocUpload = this.inputChangeHandlerDocUpload.bind(this);
        this.salvaDocumentUpload = this.salvaDocumentUpload.bind(this);
        this.inizilizzaNuovoDocUpload = this.inizilizzaNuovoDocUpload.bind(this);
        this.cloneProdottoButton = this.cloneProdottoButton.bind(this);
        this.showConfirmPanelUploadJSON = this.showConfirmPanelUploadJSON.bind(this);
        this.inizilizzaModificaDocUpload = this.inizilizzaModificaDocUpload.bind(this);
        this.showConfirmPanelPrint = this.showConfirmPanelPrint.bind(this);
        this.inputChangeHandlerDocPrint = this.inputChangeHandlerDocPrint.bind(this);
        this.salvaDocumentPrint = this.salvaDocumentPrint.bind(this);
        this.inizilizzaNuovoDocPrint = this.inizilizzaNuovoDocPrint.bind(this);
        this.inizilizzaModificaDocPrint = this.inizilizzaModificaDocPrint.bind(this);
        this.controllaListaTipoCoperturaGaranzie = this.controllaListaTipoCoperturaGaranzie.bind(this);
        this.state = {
            showConfirm: false,
            showConfirmUploadJSON: false,
            showConfirmPrintDocument: false,
            onClickModifica: false
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        // cambio la tab-selected a Home
        if (this.props.tabSelected === undefined
            || this.props.tabSelected === null
            || this.props.tabSelected === "") {
            this.props.changeSelectedTab("home-tab");
        }

        let idProdotto;
        if (isNullOrUndefined(this.props.location.state) || isNullOrUndefined(this.props.location.state.id)) {
            // se non c'e la id sullo stato uso quello che c'e sullo store 
            idProdotto = this.props.prodotto.id
        } else {
            idProdotto = this.props.location.state.id
        }

        //faccio la chiamata REST per recuperare i dettagli 
        console.log(this.componentName + '[ID] ' + idProdotto);

        this.props.getProdottoDetails(idProdotto).then(
            resolve => {
                this.props.getDocumentiProdottoQuotazione(idProdotto)
            }
        )
        this.props.getProdottoServiziEsterni(idProdotto);
        this.props.getProdottoFirmaDigitale(idProdotto);
        Prism.highlightAll()
    }

    componentDidUpdate() {
        Prism.highlightAll()
    }

    modificaProdottoButton() {
        console.log(this.componentName + 'modificaProdottoButton');

        if (this.props.prodotto.numEmissioni !== undefined && this.props.prodotto.numEmissioni > 0
            && opt("APP", "MODIFICA_PRODOTTO_EMESSO", "false") !== "true") {
            // this.props.showModificaWarning();
            // return;
        }
        this.setState({ onClickModifica: true });

        this.props.inizilizzaModificaProdotto().then(
            resolve => {
                if (this.props.prodotto.coass) {
                    this.props.prodotto.listaProdottoCmpPojo.forEach((element, index) => {
                        this.props.updateItemsPuntoVendita(index, element.prodottoCmp.idCompagnia)
                    });
                } else if (this.props.prodotto.flAssicurazioneCongiunta) {
                    this.props.prodotto.listaProdottoCmpPojo.forEach((element, index) => {
                        this.props.updateItemsPuntoVendita(index, element.prodottoCmp.idCompagnia)
                    });
                } else {
                    this.props.getListaPuntiVenditaOfCompagnia(this.props.prodotto.idCompagnia)
                }

                // resolve => {
                this.props.history.push({
                    pathname: '/prodotto/create', state: {
                        id: this.props.prodotto.id,
                        modifica: true
                    }
                })
            },
            reject => {
                console.log(this.componentName + 'inizilizzaModificaProdotto KO');
            }
        )
    }
    showConfirmPanel() {
        this.setState({ showConfirm: !this.state.showConfirm })
    }

    deleteProdotto() {
        console.log(this.componentName + 'deleteProdotto');
        this.setState({ showConfirm: false });

        this.props.deleteProdotto().then(
            resolve => {
                this.props.history.push({
                    pathname: '/prodotto/listOrigine'
                });
            }, reject => {
                console.log(this.componentName + 'deleteProdotto KO');
            }
        )
    }

    changeSelectedTab(e) {
        if (e !== null && e !== undefined) {
            let idTab = e.target.id;
            this.props.changeSelectedTab(idTab);

            if (idTab === "docOut-tab") {
                this.props.getDocumentiProdottoUpload(this.props.prodotto.id)
            } else if (idTab === "docPrint-tab") {
                this.props.getDocumentiProdottoPrint(this.props.prodotto.id)
            }
        }
    }

    modificaProvvigioniButton() {
        this.props.clearFiltriProvvigioni().then(
            resolve => {
                this.props.history.push({
                    pathname: '/prodotto/provviggioniEdit'
                });
            },
            reject => {
                console.log("clearFiltriProvvigioni" + 'KO');
            }
        )
    }

    modificaProvvigioniPassiveButton() {
        console.log(this.componentName + 'modificaProvvigioniPassiveButton');

        this.props.clearFiltriProvvigioniPassive().then(
            resolve => {
                this.props.history.push({
                    pathname: '/prodotto/provviggioniPassiveEdit'
                });
            },
            reject => {
                console.log("clearFiltriProvvigioni" + 'KO');
            }
        )
    }

    microCategoriaDetailsButton() {
        console.log(this.componentName + 'microCategoriaDetailsButton');
        this.props.history.push({
            pathname: '/microCategorie/details', state: {
                id: this.props.prodotto.microCategoria.id
            }
        });
    }

    indietroButton() {
        console.log(this.componentName + 'indietroButton');
        this.props.history.push({
            pathname: '/prodotto/detailsOrgine', state: {
                id: this.props.prodotto.id
            }
        }
        );
    }

    tornaAllaLista() {
        console.log(this.componentName + 'tornaAllaLista');
        this.props.history.push({
            pathname: '/prodotto/listOrigine'
        }
        );
    }

    prodottoFiglioDetailsButton() {
        console.log(this.componentName + 'prodottoFiglioDetailsButton');
        this.props.getProdottoDetails(this.props.prodotto.prodottoFiglio.id);
    }

    prodottoPadreDetailsButton() {
        console.log(this.componentName + 'prodottoPadreDetailsButton');
        this.props.getProdottoDetails(this.props.prodotto.prodottoPadre.id);

    }

    prodottoOrigineDetailsButton() {
        console.log(this.componentName + 'prodottoOrigineDetailsButton');
        this.props.getProdottoDetails(this.props.prodotto.prodottoOrigine.id);
    }

    cloneProdottoButton() {
        console.log(this.componentName + 'cloneProdottoButton');

        let idProdottoVecchio = this.props.prodotto.id;

        this.props.inizilizzaCloneProdotto().then(
            resolve => {
                this.props.inizilizzaModificaProdotto().then(
                    resolve => {
                        if (this.props.prodotto.coass) {
                            this.props.prodotto.listaProdottoCmpPojo.forEach((element, index) => {
                                this.props.updateItemsPuntoVendita(index, element.prodottoCmp.idCompagnia)
                            });

                        } else if (this.props.prodotto.flAssicurazioneCongiunta === true) {
                            this.props.prodotto.listaProdottoCmpPojo.forEach((element, index) => {
                                this.props.updateItemsPuntoVendita(index, element.prodottoCmp.idCompagnia)
                            });
                        } else {
                            this.props.getListaPuntiVenditaOfCompagnia(this.props.prodotto.idCompagnia)
                        }
                        // resolve => {
                        this.props.history.push({

                            pathname: '/prodotto/create', state: {
                                clone: true,
                                idProdotto: idProdottoVecchio

                            }
                        })
                    },
                    reject => {
                        console.log(this.componentName + 'inizilizzaModificaProdotto KO');
                    })
            },
            reject => {
                console.log('inizilizzaCloneProdotto KO');
            }
        )
    }

    nuovoVersioneButton() {
        console.log(this.componentName + 'nuovoVersioneButton');

        this.props.inizilizzaNuovaVesioneProdotto().then(
            resolve => {
                this.props.inizilizzaModificaProdotto().then(
                    resolve => {
                        if (this.props.prodotto.coass === true) {
                            this.props.prodotto.listaProdottoCmpPojo.forEach((element, index) => {
                                this.props.updateItemsPuntoVendita(index, element.prodottoCmp.idCompagnia)
                            });
                        }
                        // TODO: Simile a coass
                        else if (this.props.prodotto.flAssicurazioneCongiunta === true) {
                            this.props.prodotto.listaProdottoCmpPojo.forEach((element, index) => {
                                this.props.updateItemsPuntoVendita(index, element.prodottoCmp.idCompagnia)
                            });
                        }
                        else {
                            this.props.getListaPuntiVenditaOfCompagnia(this.props.prodotto.idCompagnia)
                        }
                        // resolve => {
                        this.props.history.push({

                            pathname: '/prodotto/create', state: {
                                versione: true
                            }
                        })
                    },
                    reject => {
                        console.log(this.componentName + 'inizilizzaModificaProdotto KO');
                    })
            },
            reject => {
                console.log('inizilizzaNuovaVesioneProdotto KO');
            }
        )
    }

    downloadDocument(documentId) {
        console.log(this.componentName + ' downloadDocument ');
        this.props.downloadDocument(documentId)
    }

    showConfirmPanelUpload() {
        console.log(this.componentName + ' showConfirmPanelUpload ');
        this.props.showPopUP(!this.props.showConfirmUpload);
    }

    inputChangeHandlerDocUpload(e) {
        let id = e.target.id;
        let value = e.target.value;
        console.log(this.componentName + ' inputChangeHandlerDocUpload [id]: ' + id + "[value]: " + value);

        this.props.inputChangeHandlerDocUpload(id, value);
    }

    salvaDocumentUpload() {
        console.log(this.componentName + ' salvaDocumentUpload ');
        this.showConfirmPanelUpload();

        this.props.salvaDocumentUpload().then(

            resolve => {
                this.props.getDocumentiProdottoUpload(this.props.prodotto.id);
            }
        )
    }

    inizilizzaNuovoDocUpload(order) {
        console.log(this.componentName + ' inizilizzaNuovoDocUpload ');
        this.props.inizilizzaNuovoDocUpload(order).then(
            resolve => {
                this.showConfirmPanelUpload();
                return resolve;
            }
        )
    }

    inizilizzaModificaDocUpload(doc) {
        console.log(this.componentName + ' inizilizzaModificaDocUpload ');
        this.props.inizilizzaModificaDocUpload(doc).then(
            resolve => {
                this.showConfirmPanelUpload();
            }
        )
    }

    showConfirmPanelUploadJSON() {
        this.setState({ showConfirmUploadJSON: !this.state.showConfirmUploadJSON })
    }

    showConfirmPanelPrint() {
        console.log(this.componentName + ' showConfirmPanelPrint ');
        this.setState({ showConfirmPrintDocument: !this.state.showConfirmPrintDocument });
    }

    inputChangeHandlerDocPrint(e) {
        let id = e.target.id;
        let value = e.target.value;
        console.log(this.componentName + ' inputChangeHandlerDocPrint [id]: ' + id + "[value]: " + value);

        this.props.inputChangeHandlerDocPrint(id, value);
    }

    salvaDocumentPrint() {
        console.log(this.componentName + ' salvaDocumentUpload ');
        this.showConfirmPanelPrint();

        this.props.salvaDocumentPrint().then(

            resolve => {
                this.props.getDocumentiProdottoPrint(this.props.prodotto.id);
            }
        )
    }

    inizilizzaNuovoDocPrint(order) {
        console.log(this.componentName + ' inizilizzaNuovoDocUpload ');
        this.props.inizilizzaNuovoDocPrint(order).then(
            resolve => {
                this.showConfirmPanelPrint();
                return resolve;
            }
        )
    }

    inizilizzaModificaDocPrint(doc) {
        console.log(this.componentName + ' inizilizzaModificaDocPrint ');
        this.props.inizilizzaModificaDocPrint(doc).then(
            resolve => {
                this.showConfirmPanelPrint();
            }
        )
    }

    esportaButton = () => {
        console.log(this.componentName + " esportaButton ");
        this.props.exportProduct();
    }

    controllaListaTipoCoperturaGaranzie(lista) {
        let listaResult = [];
        if (!isNullOrUndefined(lista)) {
            lista.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoGaranzia) && element.prodottoGaranzia.tipoCopertura === "OB" || element.prodottoGaranzia.tipoCopertura === "FA") {
                    listaResult.push(element);
                }
            });
        }
        return listaResult;
    }


    render() {
        console.log(this.componentName + 'render');
        let prodottoGaranzia = this.props.prodotto.listaProdottoGaranziaPojo;
        let sinistriList = this.props.prodotto.listSinistri;
        let sinistri = {};
        if (sinistriList !== undefined && sinistriList !== null && sinistriList.length > 0) {
            sinistri = sinistriList[0];
        }

        let idProdotto;
        if (isNullOrUndefined(this.props.location.state) || isNullOrUndefined(this.props.location.state.id)) {
            // se non c'e la id sullo stato uso quello che c'e sullo store 
            idProdotto = this.props.prodotto.id
        } else {
            idProdotto = this.props.location.state.id
        }

        return (
            <div className="card">
                <div className="card-header">
                    <h3>{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO', 'Dettaglio')}: {this.props.prodotto && this.props.prodotto.nome ? this.props.prodotto.nome : null}  {this.props.prodotto && this.props.prodotto.nomeVersione ? "- " + i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE', 'Versione') + ": " + this.props.prodotto.nomeVersione : null} ( id: {this.props.prodotto.id})</h3>
                </div>
                <div className="card-body">

                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className={this.props.tabSelected === "home-tab" ? "active" : "nav-item"} >
                            <a className={this.props.tabSelected === "home-tab" ? "nav-link active" : "nav-link"} id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true" onClick={this.changeSelectedTab} >{i18n('ARM_CORE_PRODUCT.SHARED.PRODOTTO', 'Prodotto')}</a>
                        </li>
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_GARANZIE') &&
                            <li className={this.props.tabSelected === "garanzie-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "garanzie-tab" ? "nav-link active" : "nav-link"} id="garanzie-tab" data-toggle="tab" href="#garanzie" role="tab" aria-controls="garanzie" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.MENUTOP.GARANZIE', 'Garanzie')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_INTERMEDIARI') &&
                            <li className={this.props.tabSelected === "intermediari-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "intermediari-tab" ? "nav-link active" : "nav-link"} id="intermediari-tab" data-toggle="tab" href="#intermediari" role="tab" aria-controls="intermediari" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMEDIARI', 'Intermediari')}</a>
                            </li>
                        }

                        {this.props.prodotto.listaProdottoCmpPojo && this.props.prodotto.listaProdottoCmpPojo.length > 1 &&
                            isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_INTERMEDIARI') &&
                            <li className={this.props.tabSelected === "compagnie-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "compagnie-tab" ? "nav-link active" : "nav-link"} id="compagnie-tab" data-toggle="tab" href="#compagnie" role="tab" aria-controls="compagnie" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIE', 'Compagnie')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_PROVV_ATTIVE') &&
                            <li className={this.props.tabSelected === "provAttive-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "provAttive-tab" ? "nav-link active" : "nav-link"} id="provAttive-tab" data-toggle="tab" href="#provAttive" role="tab" aria-controls="provAttive" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PROVV_ATTIVE', 'Provvigioni Attive')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_PROVV_PASSIVE') &&
                            <li className={this.props.tabSelected === "provPassive-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "provPassive-tab" ? "nav-link active" : "nav-link"} id="provPassive-tab" data-toggle="tab" href="#provPassive" role="tab" aria-controls="provPassive" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PROVV_PASSIVE', 'Provvigioni Passive')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_QUESTIONARI') &&
                            <li className={this.props.tabSelected === "qst-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "qst-tab" ? "nav-link active" : "nav-link"} id="qst-tab" data-toggle="tab" href="#qst" role="tab" aria-controls="qst" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.QUESTIONARI', 'Questionari')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_DOC_IN') &&
                            <li className={this.props.tabSelected === "docIn-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "docIn-tab" ? "nav-link active" : "nav-link"} id="docIn-tab" data-toggle="tab" href="#docIn" role="tab" aria-controls="docIn" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.DOCUMENTI_OUT', 'Documenti Out')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_DOC_OUT') &&
                            <li className={this.props.tabSelected === "docOut-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "docOut-tab" ? "nav-link active" : "nav-link"} id="docOut-tab" data-toggle="tab" href="#docOut" role="tab" aria-controls="docOut" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.DOCUMENTI_IN', 'Documenti In')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.DOCUMENTI_PRINT') &&
                            <li className={this.props.tabSelected === "docPrint-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "docPrint-tab" ? "nav-link active" : "nav-link"} id="docPrint-tab" data-toggle="tab" href="#docPrint" role="tab" aria-controls="docPrint" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.DOCUMENTI_PRINT', 'Documenti Print')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_FRAZIONAMENTI') &&
                            <li className={this.props.tabSelected === "frazionamenti-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "frazionamenti-tab" ? "nav-link active" : "nav-link"} id="frazionamenti-tab" data-toggle="tab" href="#frazionamenti" role="tab" aria-controls="frazionamenti" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.FRAZIONAMENTI', 'Frazionamenti')}</a>
                            </li>}

                        {opt("APP", "FL_VIEW_TAB_DURATA", "false") === "true" &&
                            <li className={this.props.tabSelected === "durata-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "durata-tab" ? "nav-link active" : "nav-link"} id="durata-tab" data-toggle="tab" href="#durataA" role="tab" aria-controls="durataA" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.DURATA ', 'Durata ')}</a>
                            </li>}

                        {opt("APP", "FL_VIEW_PRODOTTO_TAB_SCONTO", "false") === "true" &&
                            <li className={this.props.tabSelected === "sconto-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "sconto-tab" ? "nav-link active" : "nav-link"} id="sconto-tab" data-toggle="tab" href="#sconto" role="tab" aria-controls="sconto" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.SCONTO ', 'Sconto ')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_PAGAMENTI') &&
                            <li className={this.props.tabSelected === "pagamenti-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "pagamenti-tab" ? "nav-link active" : "nav-link"} id="pagamenti-tab" data-toggle="tab" href="#pagamenti" role="tab" aria-controls="pagamenti" aria-selected="true" onClick={this.changeSelectedTab}>
                                    {i18n('ARM_CORE_PRODUCT.SHARED.PAGAMENTI', 'Pagamenti')}
                                </a>
                            </li>
                        }


                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_REGOLA') &&
                            <li className={this.props.tabSelected === "regola-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "regola-tab" ? "nav-link active" : "nav-link"} id="regola-tab" data-toggle="tab" href="#regola" role="tab" aria-controls="regola" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.REGOLA', 'Regola')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_SINISTRI') &&
                            <li className={this.props.tabSelected === "sinistri-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "sinistri-tab" ? "nav-link active" : "nav-link"} id="sinistri-tab" data-toggle="tab" href="#sinistri" role="tab" aria-controls="sinistri" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.SINISTRI', 'Sinistri')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_SERVIZIO_ESTERN') &&
                            <li className={this.props.tabSelected === "servizioEsterno-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "servizioEsterno-tab" ? "nav-link active" : "nav-link"} id="servizioEsterno-tab" data-toggle="tab" href="#servizioEsterno" role="tab" aria-controls="servizioEsterno" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.SERVIZIOESTERNO', 'Servizio Esterno')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PACCHETTI') &&
                            <li className={this.props.tabSelected === "pacchetto-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "pacchetto-tab" ? "nav-link active" : "nav-link"} id="pacchetto-tab" data-toggle="tab" href="#pacchetto" role="tab" aria-controls="pacchetto" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.MENUTOP.PACCHETTO', 'Pacchetto')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_LINEA') && this.props.prodotto.microCategoria && this.props.prodotto.microCategoria.flFinanziaria &&
                            <li className={this.props.tabSelected === "linea-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "linea-tab" ? "nav-link active" : "nav-link"} id="linea-tab" data-toggle="tab" href="#linea" role="tab" aria-controls="linea" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA', 'Linea')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_CONVENZIONE') &&
                            <li className={this.props.tabSelected === "convenzione-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "convenzione-tab" ? "nav-link active" : "nav-link"} id="convenzione-tab" data-toggle="tab" href="#convenzione" role="tab" aria-controls="convenzione" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.CONVENZIONE', 'Convenzione')}</a>
                            </li>
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_OPERAZIONI') &&
                            <li className={this.props.tabSelected === "operazioni-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "operazioni-tab" ? "nav-link active" : "nav-link"} id="operazioni-tab" data-toggle="tab" href="#operazioni" role="tab" aria-controls="operazioni" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.OPERAZIONI', 'Operazioni')}</a>
                            </li>
                        }

                        {opt("APP", "FIRMA_DIGITALE", "false") === "TRUE" &&
                            <li className={this.props.tabSelected === "firmaDigitale-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "firmaDigitale-tab" ? "nav-link active" : "nav-link"} id="firmaDigitale-tab" data-toggle="tab" href="#firmaDigitale" role="tab" aria-controls="firmaDigitale" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.FIRMA_DIGITALE', 'Firma Digitale')}</a>
                            </li>
                        }

                        {opt("APP", "REGOLA_ANNULLI", "false") === "TRUE" &&
                            <li className={this.props.tabSelected === "regolaAnnulli-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "regolaAnnulli-tab" ? "nav-link active" : "nav-link"} id="regolaAnnulli-tab" data-toggle="tab" href="#regolaAnnulli" role="tab" aria-controls="regolaAnnulli" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.REGOLA_ANNULLI', 'Regola Annulli')}</a>
                            </li>
                        }

                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className={this.props.tabSelected === 'home-tab' ? 'tab-pane active' : 'tab-pane'} id="home" role="tabpanel" aria-labelledby="home-tab">
                            {this.props.prodotto ?
                                <ProdottoDetailsCard prodotto={this.props.prodotto}
                                    microCategoriaDetailsButton={this.microCategoriaDetailsButton} />
                                :
                                null
                            }

                        </div>
                        <div className={this.props.tabSelected === 'regola-tab' ? 'tab-pane active' : 'tab-pane'} id="regola" role="tabpanel" aria-labelledby="regola-tab">
                            <div className="row mt-4">
                                <div className={isAuth('SHOW_DOC_QUOTAZIONE_REGOLA_PRODUCT') ? "col-6 mt-4" : "col-12 mt-4" }>
                                    <Editor
                                        textareaClassName="form-control-regola"
                                        value={this.props.prodotto.ruleJavascript}
                                        padding={30}
                                        disabled={this.props.disabled}
                                        highlight={(code) => this.props.prodotto.ruleJavascript ? Prism.highlight(this.props.prodotto.ruleJavascript, Prism.languages.javascript, 'javascript') : null}
                                        style={{
                                            width: "100%",
                                            fontFamily: '"Fira code", "Fira Mono", monospace',
                                            fontSize: 12,
                                        }} >
                                    </Editor>
                                </div>

                                {isAuth('SHOW_DOC_QUOTAZIONE_REGOLA_PRODUCT') &&
                                    <ProdottoQuotazione
                                        rows={this.props.prodotto.listDocumentiQuotazione}
                                        idProdotto={this.props.prodotto.id}
                                        deleteDocumentPolizza={this.props.deleteDocumentPolizza}
                                        downloadDocument={this.downloadDocument}
                                        quotationJSON={this.props.quotationJSON}
                                        prodotto={this.props.prodotto}
                                        ruleLog={this.props.prodotto.ruleLog}
                                        premio={this.props.prodotto.premio}
                                        getRulelog={this.props.getRulelog}
                                        getDocumentiProdottoQuotazione={this.props.getDocumentiProdottoQuotazione}
                                    />
                                }

                            </div>
                        </div>

                        <div className={this.props.tabSelected === 'garanzie-tab' ? 'tab-pane active' : 'tab-pane'} id="garanzie" role="tabpanel" aria-labelledby="garanzie-tab">
                            <GaranzieTable rows={this.controllaListaTipoCoperturaGaranzie(prodottoGaranzia)} history={this.props.history} source="prodottoDetails" ></GaranzieTable>
                        </div>
                        <div className={this.props.tabSelected === 'intermediari-tab' ? 'tab-pane active' : 'tab-pane'} id="intermediari" role="tabpanel" aria-labelledby="intermediari-tab">
                            <IntermediariTable prodotto={this.props.prodotto} rows={this.props.prodotto.listaProdottoIntermediarioPojo} source="prodottoDetails" ></IntermediariTable>
                        </div>

                        <div className={this.props.tabSelected === 'compagnie-tab' ? 'tab-pane active' : 'tab-pane'} id="compagnie" role="tabpanel" aria-labelledby="compagnie-tab">
                            <CompagniaTable rows={this.props.prodotto.listaProdottoCmpPojo} ></CompagniaTable>
                        </div>

                        <div className={this.props.tabSelected === 'provAttive-tab' ? 'tab-pane active' : 'tab-pane'} id="provAttive" role="tabpanel" aria-labelledby="provAttive-tab">
                            <ProvvigioniTable rows={this.props.prodotto.listaProvvigioniAttive} flProdottoSoluzione={this.props.prodotto.flProdottoSoluzione} tipo="attive" ></ProvvigioniTable>
                        </div>
                        <div className={this.props.tabSelected === 'provPassive-tab' ? 'tab-pane active' : 'tab-pane'} id="provPassive" role="tabpanel" aria-labelledby="provPassive-tab">
                            <ProvvigioniTable rows={this.props.prodotto.listaProvvigioniPassive} flProdottoSoluzione={this.props.prodotto.flProdottoSoluzione} tipo="passive" ></ProvvigioniTable>
                        </div>
                        <div className={this.props.tabSelected === 'versione-tab' ? 'tab-pane active' : 'tab-pane'} id="versione" role="tabpanel" aria-labelledby="versione-tab">
                            <ProdottoTable source="prodottoDetails" history={this.props.history} rows={this.props.prodotto.listaProdottiVersione}  ></ProdottoTable>
                        </div>
                        <div className={this.props.tabSelected === 'qst-tab' ? 'tab-pane active' : 'tab-pane'} id="qst" role="tabpanel" aria-labelledby="qst-tab">
                            <dl className="row">
                                <dt className="col-sm-2 col-8 mt-2">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIA.QUESTIONARIO_QUOTAZIONE', 'Questionario Quotazione')}</dt>
                                <dd className="col-sm-4 col-4 mt-2">{this.props.prodotto.microCategoria && this.props.prodotto.microCategoria.codQuestionarioQuotazione ?
                                    this.props.prodotto.microCategoria.codQuestionarioQuotazione : "-"}
                                </dd>
                                <dt className="col-sm-2 col-8 mt-2">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIA.QUESTIONARIO_EMISSIONE', 'Questionario Emissione')}</dt>
                                <dd className="col-sm-4 col-4 mt-2">
                                    {this.props.prodotto.microCategoria && this.props.prodotto.microCategoria.codQuestionarioEmissione ?
                                        this.props.prodotto.microCategoria.codQuestionarioEmissione
                                        : "-"}</dd>
                            </dl>
                            <dl className="row">
                                <dt className="col-sm-2 col-8 mt-2">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIA.QUESTIONARIO_ACCETTAZIONE', 'Questionario Accettazione')}</dt>
                                <dd className="col-sm-4 col-4 mt-2">{this.props.prodotto.microCategoria && this.props.prodotto.microCategoria.codQuestionarioAccettazione ?
                                    this.props.prodotto.microCategoria.codQuestionarioAccettazione : "-"}
                                </dd>
                            </dl>
                            {opt("APP", "FL_VIEW_SINISTRO", "false") === "true" ?
                                <dl className="row">
                                    <dt className="col-sm-2 col-8 mt-2">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIA.QUESTIONARIO_SINISTRO', 'Questionario Sinistro')}</dt>
                                    <dd className="col-sm-4 col-4 mt-2">{this.props.prodotto.microCategoria && this.props.prodotto.microCategoria.codQuestionarioSinistro ?
                                        this.props.prodotto.microCategoria.codQuestionarioSinistro : "-"}
                                    </dd>
                                </dl>
                                : null}
                        </div>
                        <div className={this.props.tabSelected === 'docIn-tab' ? 'tab-pane active' : 'tab-pane'} id="docIn" role="tabpanel" aria-labelledby="docIn-tab">
                            <ProdottoDocument
                                getListaDocumenti={this.props.getListaDocumenti}
                                modificaProdottoDocument={this.props.modificaProdottoDocument}
                                deleteProdottoDocument={this.props.deleteProdottoDocument}
                                downloadDocument={this.downloadDocument}
                                idProdotto={idProdotto}
                                rows={this.props.prodotto.listDocumenti} />
                            <ProdottoDocumentPolizza
                                getDocumentiPolizza={this.props.getDocumentiProdottoPolizza}
                                deleteDocumentPolizza={this.props.deleteDocumentPolizza}
                                downloadDocument={this.downloadDocument}
                                idProdotto={idProdotto}
                                rows={this.props.prodotto.listDocumentiPolizza} />
                        </div>
                        <div className={this.props.tabSelected === 'frazionamenti-tab' ? 'tab-pane active' : 'tab-pane'} id="frazionamenti" role="tabpanel" aria-labelledby="frazionamenti-tab">
                            <FrazionamentoTable frazionamenti={this.props.prodotto.listFrazionamenti} />

                        </div>
                        <div className={this.props.tabSelected === 'pagamenti-tab' ? 'tab-pane active' : 'tab-pane'} id="pagamenti" role="tabpanel" aria-labelledby="pagamenti-tab">
                            <PagamentoTable pagamenti={this.props.prodotto.listPagamenti} />

                        </div>
                        <div className={this.props.tabSelected === 'durata-tab' ? 'tab-pane active' : 'tab-pane'} id="durataA" role="tabpanel" aria-labelledby="durata-tab">
                            <DurataTable durataA={this.props.prodotto.listDurata} />

                        </div>
                        {opt("APP", "FL_VIEW_PRODOTTO_TAB_SCONTO", "false") === "true" &&
                            <div className={this.props.tabSelected === 'sconto-tab' ? 'tab-pane active' : 'tab-pane'} id="sconto" role="tabpanel" aria-labelledby="sconto-tab">
                                <ScontoTable listaSconto={this.props.prodotto.listaSconto} />

                            </div>
                        }
                        <div className={this.props.tabSelected === 'operazioni-tab' ? 'tab-pane active' : 'tab-pane'} id="operazioni" role="tabpanel" aria-labelledby="operazioni-tab">
                            <OperazioniTable operazioni={this.props.prodotto.listProdottoOperazione}
                                modificaProdottoOperazione={this.props.modificaProdottoOperazione}
                                getListaOperazioni={this.props.getListaOperazioni}
                                idProdotto={this.props.prodotto.id} />

                        </div>

                        <div className={this.props.tabSelected === 'docOut-tab' ? 'tab-pane active' : 'tab-pane'} id="docOut" role="tabpanel" aria-labelledby="docOut-tab">
                            <ProdottoDocumentUpload document={this.props.documentUpload}
                                inputChangeHandler={this.inputChangeHandlerDocUpload}
                                rows={this.props.prodotto.listDocumentiUpload}
                                salvaDocumentUpload={this.salvaDocumentUpload}
                                inizilizzaNuovoDocUpload={this.inizilizzaNuovoDocUpload}
                                inizilizzaModificaDocUpload={this.inizilizzaModificaDocUpload}
                                showConfirm={this.props.showConfirmUpload}
                                deleteProdottoDocumentUpload={this.props.deleteProdottoDocumentUpload}
                                idProdotto={this.props.prodotto.id}
                                getDocumentiProdottoUpload={this.props.getDocumentiProdottoUpload}
                                showConfirmPanel={this.showConfirmPanelUpload} />
                        </div>

                        <div className={this.props.tabSelected === 'docPrint-tab' ? 'tab-pane active' : 'tab-pane'} id="docPrint" role="tabpanel" aria-labelledby="docPrint-tab">
                            <ProdottoDocumentPrint document={this.props.documentPrint}
                                inputChangeHandler={this.inputChangeHandlerDocPrint}
                                rows={this.props.prodotto.listDocumentiPrint}
                                salvaDocumentPrint={this.salvaDocumentPrint}
                                inizilizzaNuovoDocPrint={this.inizilizzaNuovoDocPrint}
                                inizilizzaModificaDocPrint={this.inizilizzaModificaDocPrint}
                                showConfirm={this.state.showConfirmPrintDocument}
                                deleteProdottoDocumentPrint={this.props.deleteProdottoDocumentPrint}
                                idProdotto={this.props.prodotto.id}
                                getDocumentiProdottoPrint={this.props.getDocumentiProdottoPrint}
                                showConfirmPanel={this.showConfirmPanelPrint}
                                listAiPrintDocumenti={this.props.listAiPrintDocumenti}
                                downloadDocument={this.props.downloadDocumentPrint}
                                getAiPrintDocumenti={this.props.getAiPrintDocumenti} />
                        </div>


                        <div className={this.props.tabSelected === 'sinistri-tab' ? 'tab-pane active' : 'tab-pane'} id="sinistri" role="tabpanel" aria-labelledby="sinistri-tab">
                            <ProdottoSinistri prodotto={this.props.prodotto} source="prodottoDetails" sinistri={sinistri} ></ProdottoSinistri>
                        </div>

                        <div className={this.props.tabSelected === 'servizioEsterno-tab' ? 'tab-pane active' : 'tab-pane'} id="servizioEsterno" role="tabpanel" aria-labelledby="servizioEsterno-tab">
                            <ProdottoServiziEsterni source="prodottoDetails" > </ProdottoServiziEsterni>
                        </div>

                        <div className={this.props.tabSelected === 'firmaDigitale-tab' ? 'tab-pane active' : 'tab-pane'} id="firmaDigitale" role="tabpanel" aria-labelledby="firmaDigitale-tab">
                            <FirmaDigitale source="prodottoDetails" disabled={this.state.onClickModifica === false}> </FirmaDigitale>
                        </div>

                        <div className={this.props.tabSelected === 'docPolizza-tab' ? 'tab-pane active' : 'tab-pane'} id="docPolizza" role="tabpanel" aria-labelledby="docPolizza-tab">

                        </div>
                        <div className={this.props.tabSelected === "linea-tab" ? "tab-pane active" : "tab-pane fade"} id="linea" role="tabpanel" aria-labelledby="linea-tab">
                            <ProdottoLinea prodotto={this.props.prodotto} source="prodottoCreate" listProdottoLinea={this.props.prodotto.listProdottoLinea} inzializzaModificaLinea={this.props.inzializzaModificaFrazionamenti} downloadDocument={this.downloadDocument}></ProdottoLinea>
                        </div>
                        <div className={this.props.tabSelected === "convenzione-tab" ? "tab-pane active" : "tab-pane fade"} id="convenzione" role="tabpanel" aria-labelledby="convenzione-tab">
                            <ProdottoConvenzione prodotto={this.props.prodotto} source="prodottoCreate" listProdottoConvenzione={this.props.prodotto.listProdottoConvenzione} ></ProdottoConvenzione>
                        </div>
                        <div className={this.props.tabSelected === "pacchetto-tab" ? "tab-pane active" : "tab-pane fade"} id="pacchetto" role="tabpanel" aria-labelledby="pacchetto-tab">
                            <ProdottoPacchetto prodotto={this.props.prodotto} source="prodottoCreate" listProdottoPacchetto={this.props.prodotto.listProdottoPacchetto} listProdottoLinea={this.props.prodotto.listProdottoLinea} downloadDocument={this.downloadDocument} ></ProdottoPacchetto>
                        </div>

                        <div className={this.props.tabSelected === 'regolaAnnulli-tab' ? 'tab-pane active' : 'tab-pane'} id="regolaAnnulli" role="tabpanel" aria-labelledby="regolaAnnulli-tab">
                            <RegolaProduct source="prodottoDetails" disabled={this.state.onClickModifica === false}> </RegolaProduct>
                        </div>

                    </div>
                </div>
                <div className="card-footer">

                    {this.props.tabSelected && this.props.tabSelected === "provAttive-tab" ?
                        <div className="float-left">
                            <agui.aButton bs="primary" className="mr-3" disabled={false} icon="fas fa-edit" onClick={this.modificaProvvigioniButton}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.MODIFICA_PROVVIGIONI', 'Modifica Provvigioni')}</agui.aButton>
                        </div>
                        :
                        this.props.tabSelected && this.props.tabSelected === "provPassive-tab" ?
                            <div className="float-left">
                                <agui.aButton bs="primary" className="mr-2" icon="fas fa-edit" disabled={false} onClick={this.modificaProvvigioniPassiveButton}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.MODIFICA_PROVVIGIONI', 'Modifica Provvigioni')}</agui.aButton>
                            </div>
                            :
                            <div className="float-left">

                                {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                                    <agui.aButton bs="primary" disabled={this.props.tabSelected === "garanzie-tab"
                                        && this.props.prodotto.numEmissioni && this.props.prodotto.numEmissioni > 0} className="mr-2" icon="fas fa-edit" onClick={this.modificaProdottoButton}>{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                                }

                                {this.props.prodotto.prodottoFiglio || !isAuth('V2.ADMIN.PRODUCT.EDIT_VERSIONI_PRODOTTO') ?
                                    null
                                    :
                                    <agui.aButton bs="primary" className="mr-2" icon="fas fa-plus" onClick={this.nuovoVersioneButton}>{i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE', 'Versione')}</agui.aButton>
                                }

                                {isAuth('V2.ADMIN.PRODUCT.EDIT_VERSIONI_PRODOTTO') &&
                                    <agui.aButton bs="primary" icon="far fa-clone" onClick={this.cloneProdottoButton}>{i18n('ARM_CORE_PRODUCT.SHARED.COPIA', 'Copia')}</agui.aButton>
                                }

                                <agui.aButton bs="primary" className="ml-2" icon="fas fa-file-export" onClick={this.esportaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.ESPORTA', 'Esporta')}</agui.aButton>

                                {(isNullOrUndefined(this.props.prodotto.numEmissioni) || this.props.prodotto.numEmissioni < 1) && (isNullOrUndefined(this.props.prodotto.prodottoFiglio) || isNullOrUndefined(this.props.prodotto.prodottoFiglio.id) && isAuth('V2.ADMIN.PRODUCT.DELETE')) ?
                                    <BtnDelete onClick={this.showConfirmPanel} className="ml-2" ></BtnDelete>
                                    : null}

                            </div>
                    }
                    <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.tornaAllaLista} >{i18n('ARM_CORE_PRODUCT.SHARED.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                    <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.indietroButton} >{i18n('ARM_CORE_PRODUCT.SHARED.INDIETRO', 'Indietro')}</agui.aButton>

                </div>

                <ConfirmModalDeleteV4
                    show={this.state.showConfirm}
                    deleteOnClick={this.deleteProdotto}
                    onClose={this.showConfirmPanel} />
            </div >
        );
    }
};

function mapStateToProps(state, ownProps) {
    return {
        prodotto: state.prodotto.detailsProdotto,
        tabSelected: state.prodotto.tabSelected,
        documentUpload: state.prodotto.documentUpload,
        showConfirmUpload: state.app.showPopUp,
        listAiPrintDocumenti: state.prodotto.listAiPrintDocumenti,
        documentPrint: state.prodotto.documentPrint,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getProdottoDetails(id) {
            return dispatch(ProdottoActions.getProdottoDetails(id));
        },

        deleteProdotto() {
            return dispatch(ProdottoActions.deleteProdotto());
        },

        inizilizzaModificaProdotto() {
            return dispatch(ProdottoActions.inizilizzaModificaProdotto());
        },

        changeSelectedTab(idTab) {
            return dispatch(ProdottoActions.changeSelectedTab(idTab));
        },

        clearFiltriProvvigioni() {
            return dispatch(ProdottoActions.clearFiltriProvvigioni())
        },

        clearFiltriProvvigioniPassive() {
            return dispatch(ProdottoActions.clearFiltriProvvigioniPassive());
        },

        inizilizzaNuovaVesioneProdotto() {
            return dispatch(ProdottoActions.inizilizzaNuovaVesioneProdotto());
        },

        getListaPuntiVenditaOfCompagnia(idCompagnia) {
            return dispatch(ProdottoActions.getListaPuntiVenditaOfCompagnia(idCompagnia));
        },

        updateItemsPuntoVendita(index, value) {
            return dispatch(ProdottoActions.updateItemsPuntoVendita(index, value));
        },

        downloadDocument(documentId) {
            return dispatch(AppActions.downloadDocument(documentId));
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        inputChangeHandlerDocUpload(id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerDocUpload(id, value))
        },

        salvaDocumentUpload() {
            return dispatch(ProdottoActions.salvaDocumentUpload())
        },

        getDocumentiProdottoUpload(idProdotto) {
            return dispatch(ProdottoActions.getDocumentiProdottoUpload(idProdotto))
        },

        inizilizzaNuovoDocUpload(order) {
            return dispatch(ProdottoActions.inizilizzaNuovoDocUpload(order))
        },

        inizilizzaModificaDocUpload(doc) {
            return dispatch(ProdottoActions.inizilizzaModificaDocUpload(doc))
        },

        deleteProdottoDocument(idDocument) {
            return dispatch(ProdottoActions.deleteProdottoDocument(idDocument))
        },

        deleteDocumentPolizza(idDocument) {
            return dispatch(ProdottoActions.deleteDocument(idDocument))
        },

        deleteProdottoDocumentUpload(idDocument) {
            return dispatch(ProdottoActions.deleteProdottoDocumentUpload(idDocument))
        },

        getListaDocumenti(idProdotto) {
            return dispatch(ProdottoActions.getDocumentiProdotto(idProdotto));
        },

        getDocumentiProdottoQuotazione(idProdotto) {
            return dispatch(ProdottoActions.getDocumentiProdottoQuotazione(idProdotto));
        },

        getDocumentiProdottoPolizza(idProdotto) {
            return dispatch(ProdottoActions.getDocumentiProdottoPolizza(idProdotto));
        },

        showModificaWarning() {
            return dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.CI_SONO_POLIZZE_EMESSE_NON_PUO_PROSEGUIRE', 'Attenzione, ci sono delle polizze emesse per questo prodotto e non si può proseguire con la modifica. Invece, può creare una nuova versione')));
        },

        inizilizzaCloneProdotto() {
            return dispatch(ProdottoActions.inizilizzaCloneProdotto());
        },
        getProdottoServiziEsterni(idProdotto) {
            return dispatch(ProdottoActions.getProdottoServiziEsterni(idProdotto));
        },
        quotationJSON(id) {
            return dispatch(ProdottoActions.quotazioneJSON(id))
        },

        getRulelog(idProdotto) {
            return dispatch(ProdottoActions.getRulelog(idProdotto))
        },

        modificaProdottoDocument(doc) {
            return dispatch(ProdottoActions.modificaProdottoDocument(doc))
        },

        modificaProdottoOperazione(prodOperazione) {
            return dispatch(ProdottoActions.modificaProdottoOperazione(prodOperazione))
        },

        getListaOperazioni(idProdotto) {
            return dispatch(ProdottoActions.getListaOperazioni(idProdotto));
        },
        publiccaProdotto() {
            return dispatch(ProdottoActions.publiccaProdotto())
        },
        getAiPrintDocumenti() {
            return dispatch(ProdottoActions.getAiPrintDocumenti())
        },
        deleteProdottoDocumentPrint(idDocument) {
            return dispatch(ProdottoActions.deleteProdottoDocumentPrint(idDocument))
        },
        salvaDocumentPrint() {
            return dispatch(ProdottoActions.salvaDocumentPrint())
        },

        getDocumentiProdottoPrint(idProdotto) {
            return dispatch(ProdottoActions.getDocumentiProdottoPrint(idProdotto))
        },

        inizilizzaNuovoDocPrint(order) {
            return dispatch(ProdottoActions.inizilizzaNuovoDocPrint(order))
        },

        inizilizzaModificaDocPrint(doc) {
            return dispatch(ProdottoActions.inizilizzaModificaDocPrint(doc))
        },
        inputChangeHandlerDocPrint(id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerDocPrint(id, value))
        },
        downloadDocumentPrint(id) {
            return dispatch(ProdottoActions.downloadDocumentPrint(id))
        },

        exportProduct() {
            return dispatch(ProdottoActions.exportProduct());
        },
        getProdottoFirmaDigitale(idProdotto) {
            return dispatch(ProdottoActions.getProdottoFirmaDigitale(idProdotto));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProdottoDetails);